import { combineReducers } from 'redux';
import AuthReducer from './auth';
import UserReducer from './user';
import AppsReducer from './apps';
import NotificationsReducer from './notifications';
import PreviewAppsReducer from './previewApps';
import AuthoriseReducer from './authorise';
import UIReducer from './ui';

const rootReducer = combineReducers({
    auth:AuthReducer,
    user:UserReducer,
    apps:AppsReducer,
    notification:NotificationsReducer,
    previewApps:PreviewAppsReducer,
    authorise:AuthoriseReducer,
    ui:UIReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js